import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useSpaceAmenityFilterStyles = makeStyles({
  root: {
    ...shorthands.border(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke2),
    ...shorthands.borderRadius('16px'),
    ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalL),
    backgroundColor: tokens.colorNeutralBackground1,
  },
  heading: {
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: tokens.spacingVerticalS,
  },
  clearAllButton: {
    color: tokens.colorBrandForeground1,
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightRegular,
    gap: tokens.spacingHorizontalXS,
  },
  checkboxGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: tokens.spacingHorizontalL,
    rowGap: tokens.spacingVerticalS,
    '& label': {
      fontSize: fontScale.caption,
    },
  },
});
